module.exports = __webpack_public_path__ + "img/IMG-20200722-WA0011.8e6db552.jpg";